import React, { useEffect, useState, } from 'react'
import { Helmet, } from "react-helmet"
import Loading from '../layouts/Loading'
import { appDescription, appName, webApiRootURL } from '../../constants'
import losMuertosCoverPhoto from '../../assets/images/games/los-muertos-cover-photo.jpg'
import GetStartedComponent from './GetStartedComponent'
import { getDownloadAccess } from '../../redux/actions/getDownloadAccessActions'
import { useSelector, useDispatch, } from 'react-redux'
import moment from 'moment'
import { authorise } from '../../redux/actions/authActions'

import './GamesComponent.scss'

const GamesComponent = () => {
  const [loading, setLoading] = useState(true)
  const state = useSelector(state => ({
    auth: state.auth,
    getDownloadAccess: state.getDownloadAccess,
  }))
  const dispatch = useDispatch()
  const [showLosMuertosGameDownloadLink, setShowLosMuertosGameDownloadLink] = useState(false)

  useEffect(() => {
    setLoading(false)
    dispatch(authorise())
  }, [])

  useEffect(() => {
    if (!state.auth.loading) {
      if (state.auth.data) {
        dispatch(getDownloadAccess())
      }
    }
  }, [state.auth])
  
  useEffect(() => {
    if (!state.auth.loading && !state.getDownloadAccess.loading) {
      if (state.auth.data && state.getDownloadAccess.data) {
        if (false === state.auth.data.isAdmin) {
          // Get temporary resource access for the
          // user and check if they have access to this
          // resource. If not, redirect to home page.
          if (
            Object.keys(state.getDownloadAccess.data).includes("los-muertos-game") &&
            false !== state.getDownloadAccess.data["los-muertos-game"] &&
            moment().isBefore(moment(state.getDownloadAccess.data["los-muertos-game"].expiresAt))
          ) {
            setLoading(false)
            setShowLosMuertosGameDownloadLink(true)
          } else {
            // No access.
            setLoading(false)
          }
        } else {
          // Is admin user.
          setLoading(false)
          setShowLosMuertosGameDownloadLink(true)
        }
      } else if (state.getDownloadAccess.error) {
        setLoading(false)
      } else {
        setLoading(false)
      }
    }
  }, [state.auth, state.getDownloadAccess])

  if (loading || state.auth.loading || state.getDownloadAccess.loading) {
    return <>
      <Helmet>
        <title>Games - {appName}</title>
        <meta name="title" content={`Games - ${appName}`}/>
        <meta name="description" content={appDescription}/>
      </Helmet>
      <div className="container text-center mt-9 mb-8">
        <Loading />
      </div>
    </>
  }

  return (
    <div className='games-container'>
      <section className="py-7 py-lg-10">
        <Helmet>
          <title>Games - {appName}</title>
          <meta name="title" content={`Games - ${appName}`}/>
          <meta name="description" content={appDescription}/>
        </Helmet>
        <div className="container">
          <div className="col-md-12">
            <h1 className="mb-4 mt-7">Games</h1>
            <p className="mb-5">
              Explore the games built on the JOYSTICK platform.
            </p>
          </div>
        </div>
        <div className='container-fluid los-muertos-container'>
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <img
                  src={losMuertosCoverPhoto}
                  alt="Los Muertos Cover"
                  className="img-fluid mb-4 los-muertos-cover-photo"
                />
              </div>
              <div className="col-md-8 mt-8">
                <p className='lead'>Los Muertos Game</p>

                <p>
                  Los Muertos is the first world built using JOYSTICK's core
                  technology set in a vibrant neon Western world inspired by Día
                  de los Muertos.
                </p>

                <div>
                  Built on the JOYSTICK platform, it blends custom weapon
                  building. Players build and wager their own weapons before
                  entering combat:
                  <ul>
                    <li>Combine parts</li>
                    <li>Shape performance</li>
                    <li>Define your play-style</li>
                  </ul>
                </div>

                <p>
                  Whether you favour speed, power, range, or precision, your
                  weapon reflects how you play and how you win.
                  Weapons here aren't permanent. Bring them into battle, at your
                  own risk.
                </p>

                {showLosMuertosGameDownloadLink && (
                  <a href="/downloads/los-muertos-game" className="btn btn-primary joystick-btn">
                    Go To Download
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <GetStartedComponent/>
    </div>
  )
}

export default GamesComponent